(function () {
  var fsbRefreshTimer = null;
  var fsbRefreshInFlight = false;
  var agreementSyncInFlight = false;
  var deliveryAreaSyncInFlight = false;
  var expressAreaSyncInFlight = false;
  var expressWindowSyncInFlight = false;
  var expressThresholdSyncInFlight = false;
  var checkoutTotalObserver = null;
  var checkoutStateObserver = null;
  var checkoutSyncTimers = [];
  var latestCartState = null;
  var latestZapietCheckoutParams = null;
  var zapietCheckoutReady = false;
  var zapietEventBridgeInstalled = false;
  var zapietDomSelectionObserver = null;
  var zapietDomSelectionSyncTimers = [];
  var zapietSelectionStarted = false;
  var checkoutStateSyncQueued = false;
  var checkoutLockMarkup = null;

  function postForm(url, params, onDone, onError) {
    var body = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
      body.append(key, params[key]);
    });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
      },
      body: body.toString(),
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Request failed: ' + res.status);
        }

        return res.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        if (onDone) onDone(data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  }

  function isAgreementValid(cart) {
    if (!cartRequiresShipping(cart)) return true;

    var checkboxes = Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement]'));
    if (!checkboxes.length) return true;

    return checkboxes.every(function (checkbox) {
      return checkbox.checked;
    });
  }

  function getAgreementCheckboxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement]'));
  }

  function getAgreementAttributeInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement-attribute-input]'));
  }

  function getAgreementAttributeValue(cart) {
    return String(getCartAttributeValue(cart, 'Cart Agreement') || '')
      .trim()
      .toLowerCase() === 'true';
  }

  function updateAgreementAttributeInputs(value) {
    var nextValue = value ? 'True' : '';

    getAgreementAttributeInputs().forEach(function (input) {
      input.value = nextValue;
    });
  }

  function syncAgreementCheckboxStateFromCart(cart) {
    var confirmed = getAgreementAttributeValue(cart);
    var checkboxes = getAgreementCheckboxes();
    if (!checkboxes.length) return;

    checkboxes.forEach(function (checkbox) {
      checkbox.checked = confirmed;
    });

    updateAgreementAttributeInputs(confirmed);
  }

  function syncCartAgreementAttribute(value, onDone) {
    if (agreementSyncInFlight) return;

    agreementSyncInFlight = true;
    applyCheckoutState();
    updateAgreementAttributeInputs(value);

    postForm(
      '/cart/update.js',
      {
        'attributes[Cart Agreement]': value ? 'True' : '',
      },
      function (cart) {
        agreementSyncInFlight = false;
        if (cart && typeof cart === 'object') {
          latestCartState = cart;
        }
        if (onDone) onDone(cart);
        applyCheckoutState(cart);
      },
      function () {
        agreementSyncInFlight = false;
        if (onDone) onDone(getEffectiveCart());
        applyCheckoutState();
      }
    );
  }

  function syncAgreementAttributeIfNeeded(cart) {
    if (!cartRequiresShipping(cart)) return;

    var checkboxes = getAgreementCheckboxes();
    if (!checkboxes.length) return;

    var confirmed = isAgreementValid();
    var saved = getAgreementAttributeValue(cart);

    updateAgreementAttributeInputs(confirmed);

    if (confirmed === saved || agreementSyncInFlight) return;

    syncCartAgreementAttribute(confirmed, function (nextCart) {
      syncAgreementCheckboxStateFromCart(nextCart || cart);
    });
  }

  function isZapietCartWidgetActive() {
    return !!document.querySelector('#storePickupApp, #zapiet-checkout-methods, .zapiet-widget-wrapper');
  }

  function shouldDeferCheckoutEnableToZapiet(checkoutBtn) {
    return (
      !!checkoutBtn &&
      checkoutBtn.hasAttribute('data-zapiet-checkout-button') &&
      cartRequiresShipping() &&
      !window.seExpressInCart &&
      isZapietCartWidgetActive()
    );
  }

  function isZapietOwnedCheckoutTrigger(checkoutBtn) {
    return shouldDeferCheckoutEnableToZapiet(checkoutBtn);
  }

  function isCheckoutAllowed(cart) {
    if (!cartRequiresShipping(cart)) {
      return !isCartSyncPending();
    }

    return (
      isAgreementValid(cart) &&
      isDeliveryAreaValid(cart) &&
      isMinimumOrderMet(cart) &&
      isZapietSelectionComplete(cart) &&
      !isCartSyncPending()
    );
  }

  function applyCheckoutState(cart) {
    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;
    var checkoutAllowed = isCheckoutAllowed(cart);

    if (checkoutAllowed) {
      if (checkoutBtn.dataset.seCheckoutGuardDisabled) {
        delete checkoutBtn.dataset.seCheckoutGuardDisabled;
      }

      if (shouldDeferCheckoutEnableToZapiet(checkoutBtn)) {
        return;
      }

      if (checkoutBtn.disabled) {
        checkoutBtn.removeAttribute('disabled');
      }
      updateZapietMethodMessage(cart, false);
      return;
    }

    if (checkoutBtn.dataset.seCheckoutGuardDisabled !== 'true') {
      checkoutBtn.dataset.seCheckoutGuardDisabled = 'true';
    }
    if (!checkoutBtn.disabled) {
      checkoutBtn.setAttribute('disabled', 'disabled');
    }
    updateZapietMethodMessage(cart, true);
  }

  function queueCheckoutStateSync(cart) {
    if (checkoutStateSyncQueued) return;
    checkoutStateSyncQueued = true;

    window.requestAnimationFrame(function () {
      checkoutStateSyncQueued = false;
      applyCheckoutState(cart);
    });
  }

  function initCheckoutStateObserver() {
    var checkoutArea = document.querySelector('.cart__footer__checkout');
    if (!checkoutArea) return;

    if (checkoutStateObserver) {
      checkoutStateObserver.disconnect();
    }

    checkoutStateObserver = new MutationObserver(function () {
      queueCheckoutStateSync();
    });

    checkoutStateObserver.observe(checkoutArea, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'style', 'data-zapiet-checkout-button'],
    });
  }

  function isCartSyncPending() {
    return (
      agreementSyncInFlight ||
      deliveryAreaSyncInFlight ||
      expressAreaSyncInFlight ||
      expressWindowSyncInFlight ||
      expressThresholdSyncInFlight
    );
  }

  function unlockZapietIfExpress() {
    if (!window.seExpressInCart) return;

    ['#storePickupApp', '#zapiet-checkout-methods', '.zapiet-widget-wrapper'].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.display = 'none';
      });
    });

    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn || !checkoutBtn.parentNode) return;

    if (!checkoutBtn.hasAttribute('data-zapiet-checkout-button')) {
      applyCheckoutState();
      return;
    }

    var clone = checkoutBtn.cloneNode(true);
    clone.removeAttribute('data-zapiet-checkout-button');

    if (checkoutBtn.id) {
      clone.id = checkoutBtn.id;
    }

    clone.disabled = checkoutBtn.disabled;
    checkoutBtn.parentNode.replaceChild(clone, checkoutBtn);
    applyCheckoutState();
  }

  function applyCartSavingsState(hasSavings) {
    document.querySelectorAll('.cart__template').forEach(function (template) {
      template.classList.toggle('cart--has-savings', hasSavings);
      template.classList.toggle('cart--no-savings', !hasSavings);
    });
  }

  function readCartSavingsStateFromDom() {
    return !!document.querySelector('[data-line-items] .cart__items__row .cart__items__saving-col');
  }

  function syncCartSavingsState() {
    applyCartSavingsState(readCartSavingsStateFromDom());

    setTimeout(function () {
      applyCartSavingsState(readCartSavingsStateFromDom());
    }, 180);
  }

  function initFreeshippingBars() {
    if (typeof HCFsb === 'undefined') return;

    document.querySelectorAll('[data-hc-fsb]').forEach(function (container) {
      if (!container.id) return;
      if (container.dataset.fsbInit === '1') return;

      container.dataset.fsbInit = '1';

      try {
        var instance = new HCFsb({
          selector: '#' + container.id,
          events: ['fsb:cart:update'],
          placeholder: '(x)',
        });

        instance.update();
      } catch (error) {
        console.error(error);
      }
    });
  }

  function initFsbAddonsCarousels() {
    document.querySelectorAll('[data-hc-fsb-addons-carousel]').forEach(function (carousel) {
      var grid = carousel.querySelector('[data-hc-fsb-addons-grid]');
      if (!grid) return;
      if (grid.dataset.fsbCarouselInit === '1') return;

      var cells = Array.prototype.slice.call(grid.querySelectorAll('.addon-grid__item'));
      var prevBtn = carousel.querySelector('[data-hc-fsb-prev]');
      var nextBtn = carousel.querySelector('[data-hc-fsb-next]');

      if (!cells.length || cells.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        grid.dataset.fsbCarouselInit = '1';
        return;
      }

      var index = 0;
      var maxIndex = Math.max(cells.length - 1, 0);

      function clamp(nextIndex) {
        if (nextIndex < 0) return 0;
        if (nextIndex > maxIndex) return maxIndex;
        return nextIndex;
      }

      function setArrowState() {
        if (prevBtn) {
          if (index <= 0) {
            prevBtn.setAttribute('disabled', 'disabled');
          } else {
            prevBtn.removeAttribute('disabled');
          }
        }

        if (nextBtn) {
          if (index >= maxIndex) {
            nextBtn.setAttribute('disabled', 'disabled');
          } else {
            nextBtn.removeAttribute('disabled');
          }
        }
      }

      function goTo(nextIndex, smooth) {
        index = clamp(nextIndex);
        cells.forEach(function (cell, cellIndex) {
          if (cellIndex === index) {
            cell.classList.add('is-active');
            cell.removeAttribute('hidden');
          } else {
            cell.classList.remove('is-active');
            cell.setAttribute('hidden', 'hidden');
          }
        });
        setArrowState();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index - 1, true);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index + 1, true);
        });
      }

      grid.dataset.fsbCarouselInit = '1';
      goTo(0, false);
    });
  }

  function initFsbAddonQtySteppers() {
    if (document.body.dataset.fsbQtyInit === '1') return;
    document.body.dataset.fsbQtyInit = '1';

    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest('[data-fsb-qty-increase], [data-fsb-qty-decrease]');
      if (!btn) return;

      var wrapper = btn.closest('[data-fsb-qty-selector]');
      if (!wrapper) return;

      var input = wrapper.querySelector('[data-fsb-qty-input]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = parseInt(input.value || '1', 10);
      if (isNaN(value)) value = min;

      if (btn.hasAttribute('data-fsb-qty-increase')) {
        value += 1;
      } else {
        value -= 1;
      }

      if (value < min) value = min;
      input.value = String(value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function refreshFreeshippingSection() {
    var currentBars = Array.prototype.slice.call(document.querySelectorAll('[data-hc-fsb]'));
    if (!currentBars.length || fsbRefreshInFlight) return;

    fsbRefreshInFlight = true;

    fetch(window.location.pathname + window.location.search, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
      },
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('FSB refresh failed: ' + res.status);
        }

        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        currentBars.forEach(function (currentBar) {
          if (!currentBar.id || !currentBar.parentNode) return;

          var freshBar = doc.getElementById(currentBar.id);
          if (!freshBar) return;

          currentBar.parentNode.replaceChild(freshBar, currentBar);
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        fsbRefreshInFlight = false;
        initFreeshippingBars();
        initFsbAddonsCarousels();
      });
  }

  function addToCart(id, qty, onDone, onError) {
    postForm('/cart/add.js', { id: String(id), quantity: String(qty) }, onDone, onError);
  }

  function setVariantQty(id, qty, onDone, onError) {
    var key = 'updates[' + String(id) + ']';
    var params = {};
    params[key] = String(qty);
    postForm('/cart/update.js', params, onDone, onError);
  }

  // COMPONENT: Cart total sync — keeps the checkout CTA amount aligned with the live AJAX cart payload instead of stale server-rendered text.
  function formatCartMoney(cents, includeCurrencyCode) {
    if (typeof cents !== 'number') return '';

    var themeConfig = window.theme || {};
    var formatter = window.themeVendor && window.themeVendor.themeCurrency;
    var currencyCode =
      themeConfig.currencyCode ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'GBP';
    var price = '';

    if (formatter && typeof formatter.formatMoney === 'function') {
      try {
        price = formatter.formatMoney(cents, themeConfig.moneyFormat);
      } catch (error) {
        price = '';
      }
    }

    if (!price) {
      try {
        price = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cents / 100);
      } catch (error) {
        price = '£' + (cents / 100).toFixed(2);
      }
    }

    return includeCurrencyCode && currencyCode ? price + ' ' + currencyCode : price;
  }

  function updateCheckoutButtonAmount(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var subtotal = document.querySelector('[data-cart-subtotal-value]');
    if (subtotal) {
      subtotal.textContent = formatCartMoney(cart.total_price, true);
    }

    updateEstimatedCartTotal(cart);
  }

  function getEstimatedDeliveryFee(cart) {
    var source =
      document.querySelector('[data-cart-estimated-total-row]') ||
      document.querySelector('[data-cart-delivery-estimate]');
    if (!source || !cartRequiresShipping(cart) || window.seExpressInCart) return 0;

    var fee = parseInt(
      source.getAttribute('data-cart-standard-delivery-fee') ||
        source.getAttribute('data-standard-delivery-fee') ||
        '0',
      10
    );
    var freeDeliveryTotal = parseInt(
      source.getAttribute('data-cart-free-delivery-total') ||
        source.getAttribute('data-free-delivery-total') ||
        '0',
      10
    );

    if (freeDeliveryTotal > 0 && getCartTotalExcludingExpress(cart) >= freeDeliveryTotal) {
      return 0;
    }

    return Math.max(fee, 0);
  }

  function updateEstimatedCartTotal(cart) {
    cart = getEffectiveCart(cart);
    if (!cart || typeof cart.total_price !== 'number') return;

    var estimatedTotal = cart.total_price + getEstimatedDeliveryFee(cart);
    var formattedTotal = formatCartMoney(estimatedTotal, true);
    var total = document.querySelector('[data-cart-estimated-total]');

    if (total && formattedTotal) {
      total.textContent = formattedTotal;
    }

    updateCheckoutButtonDisplay(formattedTotal);
  }

  // DISPLAY: Zapiet applies the payable shipping rate; this estimate mirrors the merchant-configured UK threshold without altering the cart total.
  function updateDeliveryEstimate(cart) {
    var estimate = document.querySelector('[data-cart-delivery-estimate]');
    if (!estimate) return;

    var requiresShipping = cartRequiresShipping(cart);
    estimate.hidden = !requiresShipping;
    if (!requiresShipping) return;

    var fee = parseInt(estimate.getAttribute('data-standard-delivery-fee') || '0', 10);
    var freeDeliveryTotal = parseInt(estimate.getAttribute('data-free-delivery-total') || '0', 10);
    var qualifiesForFreeDelivery =
      freeDeliveryTotal > 0 && getCartTotalExcludingExpress(cart) >= freeDeliveryTotal;
    var label = estimate.querySelector('[data-cart-delivery-label]');
    var value = estimate.querySelector('[data-cart-delivery-value]');

    if (label) {
      label.textContent =
        (qualifiesForFreeDelivery
          ? estimate.getAttribute('data-free-delivery-label')
          : estimate.getAttribute('data-standard-delivery-label')) + ':';
    }

    if (value) {
      value.textContent = qualifiesForFreeDelivery ? 'Free' : formatCartMoney(fee);
    }

    updateEstimatedCartTotal(cart);
  }

  // COMPONENT: Free delivery progress uses physical merchandise only, matching the minimum-order and delivery-estimate rules after AJAX updates.
  function updateFreeDeliveryProgress(cart) {
    var qualifyingTotal = getCartTotalExcludingExpress(cart);

    document.querySelectorAll('[data-cart-progress]').forEach(function (message) {
      var limit = parseFloat(message.getAttribute('data-limit') || '0') * 100;
      if (limit <= 0) return;

      var percent = Math.min(Math.max((qualifyingTotal / limit) * 100, 0), 100);
      var leftToSpend = Math.max(limit - qualifyingTotal, 0);
      var hasSuccessMessage = message.getAttribute('data-cart-message') === 'true';

      message.style.setProperty('--bar-progress', percent + '%');
      message.classList.toggle('is-success', hasSuccessMessage && qualifyingTotal >= limit);

      message.querySelectorAll('[data-left-to-spend]').forEach(function (amount) {
        amount.textContent = formatCartMoney(leftToSpend).replace('.00', '');
      });
    });
  }

  function updateCheckoutButtonDisplay(amountText) {
    if (!amountText) return;

    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;

    var label =
      checkoutBtn.getAttribute('data-checkout-label') ||
      (checkoutBtn.value || checkoutBtn.textContent || '').split(' - ')[0].trim();
    if (!label) return;

    var nextValue = label + ' - ' + amountText;

    if (checkoutBtn.tagName === 'INPUT') {
      if (checkoutBtn.value !== nextValue) {
        checkoutBtn.value = nextValue;
      }
      return;
    }

    var text = checkoutBtn.querySelector('[data-checkout-button-text]');
    var lock = checkoutBtn.querySelector('.sk-cart-checkout-lock');
    if (lock && checkoutLockMarkup === null) {
      checkoutLockMarkup = lock.innerHTML;
    }

    if (!text) {
      checkoutBtn.textContent = '';

      if (checkoutLockMarkup) {
        lock = document.createElement('span');
        lock.className = 'sk-cart-checkout-lock';
        lock.innerHTML = checkoutLockMarkup;
        checkoutBtn.appendChild(lock);
      }

      text = document.createElement('span');
      text.setAttribute('data-checkout-button-text', '');
      checkoutBtn.appendChild(text);
    }

    if (text) {
      if (text.textContent !== nextValue) {
        text.textContent = nextValue;
      }
      return;
    }
  }

  // COMPONENT: Checkout amount mirror — the summary total is the cart UI source of truth after AJAX quantity refreshes, so the CTA mirrors that settled number.
  function syncCheckoutButtonToSummary() {
    var summaryTotal = document.querySelector('[data-cart-estimated-total]');
    if (!summaryTotal) return;

    var amountText = (summaryTotal.textContent || '').replace(/\s+/g, ' ').trim();
    if (!amountText) return;

    updateCheckoutButtonDisplay(amountText);
  }

  function initCheckoutTotalObserver() {
    var summaryTotal = document.querySelector('[data-cart-estimated-total]');
    if (!summaryTotal) return;

    if (checkoutTotalObserver) {
      checkoutTotalObserver.disconnect();
    }

    checkoutTotalObserver = new MutationObserver(function () {
      syncCheckoutButtonToSummary();
    });

    checkoutTotalObserver.observe(summaryTotal, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function clearCheckoutSyncTimers() {
    checkoutSyncTimers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    checkoutSyncTimers = [];
  }

  // PERF: Quantity changes update the summary asynchronously, so the CTA is re-synced over a short settling window to prevent stale totals from flashing to customers.
  function scheduleCheckoutButtonSync() {
    clearCheckoutSyncTimers();

    [0, 120, 280, 520, 900, 1400].forEach(function (delay) {
      checkoutSyncTimers.push(
        window.setTimeout(function () {
          syncCheckoutButtonToSummary();
        }, delay)
      );
    });
  }

  function updateCartNoteCounter() {
    var note = document.querySelector('[data-cart-note]');
    var count = document.querySelector('[data-cart-note-count]');
    if (!note || !count) return;

    count.textContent = String(note.value.length);
  }

  function getCartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function isNonShippingLineItem(item) {
    if (!item) return false;
    if (item.requires_shipping === false) return true;
    if (item.gift_card === true) return true;
    return typeof item.handle === 'string' && item.handle.indexOf('gift-card') !== -1;
  }

  function getCartAttributes(cart) {
    return cart && cart.attributes ? cart.attributes : {};
  }

  function getEffectiveCart(cart) {
    return cart || latestCartState;
  }

  // RULE: Shopify's native cart shipping state keeps digital gift cards and booking deposits out of delivery-only checkout requirements without maintaining product handle lists.
  function cartRequiresShipping(cart) {
    cart = getEffectiveCart(cart);
    if (cart && typeof cart.requires_shipping === 'boolean') {
      return cart.requires_shipping;
    }

    var cartTemplate = document.querySelector('[data-cart-requires-shipping]');
    if (!cartTemplate) return true;

    return cartTemplate.getAttribute('data-cart-requires-shipping') !== 'false';
  }

  function updateCartRequiresShippingState(cart) {
    if (!cart || typeof cart.requires_shipping !== 'boolean') return;

    document.querySelectorAll('[data-cart-requires-shipping]').forEach(function (cartTemplate) {
      cartTemplate.setAttribute('data-cart-requires-shipping', cart.requires_shipping ? 'true' : 'false');
    });
  }

  function applyShippingRequiredState(cart) {
    var requiresShipping = cartRequiresShipping(cart);

    document.querySelectorAll('[data-shipping-only-cart-feature]').forEach(function (feature) {
      feature.hidden = !requiresShipping;
    });
  }

  function normalizeDeliveryArea(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';
    if (text.indexOf('hong kong island') !== -1 || text.indexOf('hk island') !== -1) return 'hk_island';
    if (text.indexOf('new territories') !== -1) return 'new_territories';
    if (text.indexOf('kowloon') !== -1) return 'kowloon';
    return '';
  }

  function getCartAttributeValue(cart, key) {
    var attrs = getCartAttributes(cart);
    var matchedValue = '';

    Object.keys(attrs).some(function (attrKey) {
      if (String(attrKey).toLowerCase() !== String(key).toLowerCase()) return false;
      matchedValue = attrs[attrKey];
      return true;
    });

    return matchedValue;
  }

  function normalizeZapietMethod(value) {
    var method = String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (!method) return '';
    if (method.indexOf('pickup') !== -1) return 'pickup';
    if (method.indexOf('delivery') !== -1) return 'delivery';
    if (method.indexOf('shipping') !== -1) return 'shipping';
    return method;
  }

  function getZapietSelectionDetails(params, cart, options) {
    cart = getEffectiveCart(cart);
    options = options || {};
    var includeCartFallback = options.includeCartFallback !== false;

    var method = normalizeZapietMethod(
      (params && (params.method || params.checkout_method || params.checkoutMethod)) ||
        (includeCartFallback ? getCartAttributeValue(cart, 'Checkout-Method') : '')
    );
    var pickupDate = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Date') : '';
    var deliveryDate = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Date') : '';
    var shippingDate = includeCartFallback ? getCartAttributeValue(cart, 'Shipping-Date') : '';
    var pickupTime = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Time') : '';
    var deliveryTime = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Time') : '';
    var pickupLocationId = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Location-Id') : '';
    var deliveryLocationId = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Location-Id') : '';

    return {
      method: method,
      date: String((params && params.date) || pickupDate || deliveryDate || shippingDate || '').trim(),
      time: String((params && (params.start_time || params.time)) || pickupTime || deliveryTime || '').trim(),
      locationId: String((params && params.location_id) || pickupLocationId || deliveryLocationId || '').trim(),
    };
  }

  function getZapietSelectionValidation(params, cart) {
    if (!cartRequiresShipping(cart) || window.seExpressInCart || !isZapietCartWidgetActive()) {
      return {
        valid: true,
        message: '',
      };
    }

    var useCurrentSessionOnly = zapietSelectionStarted && !zapietCheckoutReady;
    var details = getZapietSelectionDetails(params, cart, {
      includeCartFallback: !useCurrentSessionOnly,
    });

    if (!details.method) {
      return {
        valid: false,
        message: 'Please select your delivery details before checkout.',
      };
    }

    if (details.method === 'delivery' || details.method === 'shipping') {
      if (!details.date) {
        return {
          valid: false,
          message: 'Please choose a delivery date before checkout.',
        };
      }
    }

    if (details.method === 'pickup') {
      if (!details.locationId) {
        return {
          valid: false,
          message: 'Please choose a pickup store before checkout.',
        };
      }

      if (!details.date) {
        return {
          valid: false,
          message: 'Please choose a pickup date before checkout.',
        };
      }
    }

    return {
      valid: true,
      message: '',
    };
  }

  function isZapietSelectionComplete(cart) {
    if (!cartRequiresShipping(cart) || window.seExpressInCart || !isZapietCartWidgetActive()) return true;

    if (zapietCheckoutReady) return true;

    // STATE: A stale cart attribute from a previous visit should not unlock checkout until
    // the customer interacts with the current Zapiet widget session on this cart page.
    if (!zapietSelectionStarted) return false;

    return getZapietSelectionValidation(latestZapietCheckoutParams, cart).valid;
  }

  function updateZapietMethodMessage(cart, checkoutBlocked) {
    var message = document.querySelector('[data-zapiet-method-message]');
    if (!message) return;

    var validation = getZapietSelectionValidation(latestZapietCheckoutParams, cart);
    var needsMethodSelection = !zapietSelectionStarted;
    var messageText = needsMethodSelection
      ? 'Please select your delivery details before checkout.'
      : validation.message;
    var shouldShow =
      !!checkoutBlocked &&
      isAgreementValid(cart) &&
      !window.seExpressInCart &&
      cartRequiresShipping(cart) &&
      isZapietCartWidgetActive() &&
      (needsMethodSelection || !validation.valid);

    message.hidden = !shouldShow;
    message.textContent = shouldShow ? messageText : 'Please select your delivery details before checkout.';
  }

  // INTEGRATION: Zapiet's UK shipping widget can update the selected date in the DOM before its event bridge is available, so this mirrors that complete selection into the existing checkout guard.
  function getZapietShippingSelectionFromDom() {
    var root = document.querySelector('#storePickupApp');
    if (!root || !isZapietCartWidgetActive()) return null;

    var methodSource =
      root.querySelector('.checkoutMethod.active .checkoutMethodName') ||
      root.querySelector('.checkoutMethod.active') ||
      root.querySelector('.checkoutMethodContainer.shipping');
    var method = normalizeZapietMethod(methodSource ? methodSource.textContent : '');

    if (!method && root.querySelector('.checkoutMethodContainer.shipping')) {
      method = 'shipping';
    }

    if (method !== 'shipping') return null;

    var isoDate = root.querySelector('#Zapiet-InputCalendar__shippingDate_ISO');
    var visibleDate = root.querySelector('#Zapiet-InputCalendar__shipping');
    var date = String((isoDate && isoDate.value) || (visibleDate && visibleDate.value) || '').trim();

    if (!date) return null;

    return {
      method: 'shipping',
      date: date,
    };
  }

  function syncZapietSelectionFromDom() {
    if (!cartRequiresShipping() || window.seExpressInCart) return false;

    var selection = getZapietShippingSelectionFromDom();
    if (!selection) return false;

    var validation = getZapietSelectionValidation(selection);
    if (!validation.valid) return false;

    var hasChanged =
      !zapietSelectionStarted ||
      !zapietCheckoutReady ||
      !latestZapietCheckoutParams ||
      latestZapietCheckoutParams.method !== selection.method ||
      latestZapietCheckoutParams.date !== selection.date;

    latestZapietCheckoutParams = selection;
    zapietSelectionStarted = true;
    zapietCheckoutReady = true;

    if (hasChanged) {
      updateZapietMethodMessage(getEffectiveCart(), false);
      applyCheckoutState();
    }

    return hasChanged;
  }

  function scheduleZapietDomSelectionSync() {
    zapietDomSelectionSyncTimers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    zapietDomSelectionSyncTimers = [];

    [0, 80, 180, 360, 720].forEach(function (delay) {
      zapietDomSelectionSyncTimers.push(
        window.setTimeout(function () {
          syncZapietSelectionFromDom();
        }, delay)
      );
    });
  }

  function initZapietDomSelectionObserver() {
    var root = document.querySelector('#storePickupApp');
    if (!root) return;

    if (zapietDomSelectionObserver) {
      zapietDomSelectionObserver.disconnect();
    }

    if (root.dataset.zapietDomSelectionSyncInit !== '1') {
      root.dataset.zapietDomSelectionSyncInit = '1';
      root.addEventListener('click', scheduleZapietDomSelectionSync, true);
      root.addEventListener('change', scheduleZapietDomSelectionSync, true);
      root.addEventListener('input', scheduleZapietDomSelectionSync, true);
    }

    zapietDomSelectionObserver = new MutationObserver(scheduleZapietDomSelectionSync);
    zapietDomSelectionObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'value', 'aria-selected', 'aria-expanded'],
    });

    scheduleZapietDomSelectionSync();
  }

  function bindZapietWidgetEvents() {
    if (zapietEventBridgeInstalled) return true;
    if (!window.ZapietEvent || typeof window.ZapietEvent.listen !== 'function') return false;

    zapietEventBridgeInstalled = true;

    window.ZapietEvent.listen('widget_loaded', function () {
      zapietSelectionStarted = false;
      zapietCheckoutReady = false;
      latestZapietCheckoutParams = null;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('selected_method', function (checkoutMethod) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = {
        method: normalizeZapietMethod(checkoutMethod),
      };
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('locationSelected', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('enableCheckout', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = true;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('checkoutEnabled', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = true;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('disableCheckout', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('checkoutDisabled', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    return true;
  }

  // SONG-DOC: STK-UK-CHECKOUT-FREEZING-20261005
  function initZapietCheckoutValidation() {
    if (window.seZapietCheckoutValidationInstalled) return;
    window.seZapietCheckoutValidationInstalled = true;

    var previousValidation = typeof window.customCheckoutValidation === 'function' ? window.customCheckoutValidation : null;

    window.customCheckoutValidation = function (params, callback) {
      function finish(previousValid) {
        if (!previousValid) {
          callback(false);
          return;
        }

        if (params) {
          zapietSelectionStarted = true;
          latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params);
          const checkoutMethod = params.method || params.checkout_method || params.checkoutMethod;
          if (checkoutMethod) {
            latestZapietCheckoutParams.method = normalizeZapietMethod(checkoutMethod);
          }
        }

        // Zapiet's method-only callback may reuse a date only from the current ready session.
        var validation = getZapietSelectionValidation(zapietCheckoutReady ? latestZapietCheckoutParams : params);
        if (!validation.valid) {
          applyCheckoutState();
          callback(false);
          return;
        }

        updateZapietMethodMessage(getEffectiveCart(), false);
        callback(true);
      }

      if (!previousValidation) {
        finish(true);
        return;
      }

      previousValidation(params, function (result) {
        finish(result !== false);
      });
    };
  }

  function getDeliveryAreaDisplayValue(areaKey) {
    if (areaKey === 'hk_island') return 'Hong Kong Island';
    if (areaKey === 'kowloon') return 'Kowloon';
    if (areaKey === 'new_territories') return 'New Territories';
    return '';
  }

  // STATE: When the legacy selector is absent, keep using the area already resolved into the cart UI so express toggles stay interactive.
  function getDeliveryAreaFromDomState() {
    var sources = [
      document.querySelector('[data-express-checkout-wrapper]'),
      document.querySelector('[data-delivery-area-block]'),
    ];

    for (var i = 0; i < sources.length; i += 1) {
      var source = sources[i];
      if (!source) continue;

      var areaKey = normalizeDeliveryArea(
        source.getAttribute('data-selected-delivery-area') || source.dataset.selectedDeliveryArea || ''
      );

      if (areaKey) return areaKey;
    }

    return '';
  }

  function getShippingMinimumTotal() {
    var source =
      document.querySelector('[data-shipping-minimum-message]') || document.querySelector('[data-delivery-area-block]');
    if (!source) return 0;

    return parseInt(source.getAttribute('data-shipping-minimum-total') || '0', 10);
  }

  function resolveDeliveryArea(cart) {
    cart = getEffectiveCart(cart);
    var areaKey = normalizeDeliveryArea(getCartAttributeValue(cart, 'delivery_area'));
    if (areaKey) return areaKey;

    var select = document.querySelector('[data-delivery-area-select]');
    if (select) {
      areaKey = normalizeDeliveryArea(select.value);
      if (areaKey) return areaKey;
    }

    return getDeliveryAreaFromDomState();
  }

  function getDeliveryAreaBlocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-delivery-area-block]'));
  }

  function isDeliveryAreaValid(cart) {
    if (!cartRequiresShipping(cart)) return true;

    var blocks = getDeliveryAreaBlocks().filter(function (wrapper) {
      return wrapper.getAttribute('data-delivery-required') === 'true';
    });
    if (!blocks.length) return true;

    if (!isShippingMethodsAvailable(cart)) return true;

    var areaKey = resolveDeliveryArea(cart);
    return !!areaKey;
  }

  function getDeliveryAvailabilityState(cart) {
    cart = getEffectiveCart(cart);
    var requiresShipping = cartRequiresShipping(cart);
    var qualifyingTotal = getCartTotalExcludingExpress(cart);
    var shippingMinimumTotal = getShippingMinimumTotal();
    var shippingMethodsAvailable = !requiresShipping || shippingMinimumTotal <= 0 || qualifyingTotal >= shippingMinimumTotal;

    return {
      requiresShipping: requiresShipping,
      qualifyingTotal: qualifyingTotal,
      shippingMinimumTotal: shippingMinimumTotal,
      shippingMethodsAvailable: shippingMethodsAvailable,
      areaKey: resolveDeliveryArea(cart),
    };
  }

  function isShippingMethodsAvailable(cart) {
    return getDeliveryAvailabilityState(cart).shippingMethodsAvailable;
  }

  // RULE: Shipping carts must meet the merchandise minimum; digital-only carts bypass delivery thresholds.
  function isMinimumOrderMet(cart) {
    return getDeliveryAvailabilityState(cart).shippingMethodsAvailable;
  }

  function applyPickupOnlyState(cart) {
    var availability = getDeliveryAvailabilityState(cart);
    var hideForPickupOnly = availability.requiresShipping && !availability.shippingMethodsAvailable;
    var hideShippingFeatures = !availability.requiresShipping || hideForPickupOnly;

    document.querySelectorAll('[data-shipping-minimum-message]').forEach(function (message) {
      message.hidden = !hideForPickupOnly;
    });

    getDeliveryAreaBlocks().forEach(function (wrapper) {
      wrapper.hidden = hideShippingFeatures;
    });
  }

  function updateDeliveryAreaUi(cart) {
    var requiresShipping = cartRequiresShipping(cart);
    var shippingMethodsAvailable = isShippingMethodsAvailable(cart);
    var areaKey = resolveDeliveryArea(cart);
    var areaLabel = getDeliveryAreaDisplayValue(areaKey);

    getDeliveryAreaBlocks().forEach(function (wrapper) {
      var select = wrapper.querySelector('[data-delivery-area-select]');
      var ruleInput = wrapper.querySelector('[data-delivery-rule-input]');
      var message = wrapper.querySelector('[data-delivery-area-message]');
      var required = wrapper.getAttribute('data-delivery-required') === 'true';
      var messageText = '';

      if (select && areaLabel && select.value !== areaLabel) {
        select.value = areaLabel;
      }

      if (ruleInput) {
        ruleInput.value = areaKey;
      }

      wrapper.setAttribute('data-selected-delivery-area', areaKey);
      wrapper.hidden = !requiresShipping || !shippingMethodsAvailable;

      if (requiresShipping && shippingMethodsAvailable && required && !areaKey) {
        messageText = 'Select your delivery area before checkout.';
      }

      if (!message) return;

      message.hidden = messageText === '';
      message.textContent = messageText;
    });
  }

  function syncDeliveryAreaAttribute(value, areaKey) {
    if (deliveryAreaSyncInFlight) return;
    deliveryAreaSyncInFlight = true;

    var params = {
      'attributes[delivery_area]': value || '',
      'attributes[delivery_rule]': areaKey || '',
    };

    postForm(
      '/cart/update.js',
      params,
      function () {
        window.location.reload();
      },
      function () {
        deliveryAreaSyncInFlight = false;
        window.location.reload();
      }
    );
  }

  function getExpressVariantIdsFromDom() {
    var variantIds = [];

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      getExpressVariantIds(wrapper).forEach(function (variantId) {
        if (variantIds.indexOf(variantId) === -1) {
          variantIds.push(variantId);
        }
      });
    });

    return variantIds;
  }

  // RULE: Delivery thresholds use physical merchandise only and ignore any express surcharge.
  function getCartTotalExcludingExpress(cart) {
    cart = getEffectiveCart(cart);
    var expressVariantIds = getExpressVariantIdsFromDom();
    var qualifyingTotal = 0;

    getCartItems(cart).forEach(function (item) {
      var variantId = item && item.variant_id ? String(item.variant_id) : '';
      var lineTotal = item && typeof item.final_line_price === 'number' ? item.final_line_price : 0;

      if (isNonShippingLineItem(item)) return;
      if (variantId && expressVariantIds.indexOf(variantId) !== -1) return;
      qualifyingTotal += lineTotal;
    });

    return Math.max(qualifyingTotal, 0);
  }

  function getExpressVariantIds(wrapper) {
    return Array.prototype.slice
      .call(wrapper.querySelectorAll('[data-express-checkout]'))
      .map(function (checkbox) {
        return checkbox.getAttribute('data-variant-id');
      })
      .filter(function (variantId) {
        return !!variantId;
      });
  }

  // RULE: The merchandise subtotal qualifies express delivery, while fee-product lines are removed from the comparison so the surcharge cannot unlock itself.
  function getExpressCartState(cart, wrapper) {
    var variantIds = getExpressVariantIds(wrapper);
    var variantIdsInCart = [];

    getCartItems(cart).forEach(function (item) {
      var variantId = item && item.variant_id ? String(item.variant_id) : '';
      if (!variantId) return;

      if (variantIds.indexOf(variantId) === -1) return;

      variantIdsInCart.push(variantId);
    });

    return {
      expressInCart: variantIdsInCart.length > 0,
      qualifyingTotal: getCartTotalExcludingExpress(cart),
      variantIdsInCart: variantIdsInCart,
    };
  }

  function syncExpressSelections(wrapper, variantIdsInCart) {
    wrapper.querySelectorAll('[data-express-checkout]').forEach(function (checkbox) {
      var variantId = checkbox.getAttribute('data-variant-id');
      checkbox.checked = variantIdsInCart.indexOf(String(variantId)) !== -1;
    });
  }

  // FEATURE: Keep the express block mounted so AJAX cart updates can reveal it immediately when the threshold is crossed.
  function syncExpressCheckoutState(cart) {
    var activeExpressSelection = false;
    var areaKey = resolveDeliveryArea(cart);

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      if (!cartRequiresShipping(cart)) {
        wrapper.hidden = true;
        wrapper.classList.add('express-checkout--hidden');
        return;
      }

      var minTotal = parseInt(wrapper.getAttribute('data-express-min-total') || '0', 10);
      var expressState = getExpressCartState(cart, wrapper);
      var isEligible = expressState.qualifyingTotal >= minTotal;
      var shouldShow = isEligible || expressState.expressInCart;

      wrapper.dataset.expressEligible = isEligible ? 'true' : 'false';
      wrapper.dataset.expressQualifyingTotal = String(expressState.qualifyingTotal);
      wrapper.dataset.selectedDeliveryArea = areaKey;
      wrapper.hidden = !shouldShow;
      wrapper.classList.toggle('express-checkout--hidden', !shouldShow);

      syncExpressSelections(wrapper, expressState.variantIdsInCart);

      if (expressState.expressInCart && isEligible) {
        activeExpressSelection = true;
      }
    });

    window.seExpressInCart = activeExpressSelection;
  }

  function applyExpressAreaState(cart) {
    var availability = getDeliveryAvailabilityState(cart);
    var shippingMethodsAvailable = availability.requiresShipping && availability.shippingMethodsAvailable;

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var areaMessage = wrapper.querySelector('[data-express-area-message]');

      // UI: Keep both express options visible so the customer can choose the surcharge directly, independent of Zapiet's selected delivery area.
      wrapper.querySelectorAll('[data-express-option-label]').forEach(function (label) {
        label.hidden = !shippingMethodsAvailable;
      });

      if (!areaMessage) return;

      areaMessage.hidden = true;
      areaMessage.textContent = '';
    });
  }

  // UX: Reuse the inline express status slot for cart action failures so the checkbox does not appear unresponsive.
  function setExpressActionMessage(wrapper, messageText) {
    if (!wrapper) return;

    var message = wrapper.querySelector('[data-express-area-message]');
    if (!message) return;

    message.hidden = !messageText;
    message.textContent = messageText || '';
  }

  function removeAreaInvalidExpressSelections(cart) {
    return;
  }

  // SAFETY: If the merchandise subtotal falls back under the threshold, remove any selected express fee lines before checkout can continue with an invalid surcharge.
  function removeThresholdInvalidExpressSelections(cart) {
    if (expressWindowSyncInFlight || expressThresholdSyncInFlight) return;

    var variantIdsToRemove = [];

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var minTotal = parseInt(wrapper.getAttribute('data-express-min-total') || '0', 10);
      var expressState = getExpressCartState(cart, wrapper);

      if (expressState.qualifyingTotal >= minTotal) return;

      expressState.variantIdsInCart.forEach(function (variantId) {
        if (variantIdsToRemove.indexOf(variantId) === -1) {
          variantIdsToRemove.push(variantId);
        }
      });
    });

    if (!variantIdsToRemove.length) return;

    expressThresholdSyncInFlight = true;
    applyCheckoutState(cart);

    function removeNext(index) {
      if (index >= variantIdsToRemove.length) {
        window.location.reload();
        return;
      }

      setVariantQty(
        variantIdsToRemove[index],
        0,
        function () {
          removeNext(index + 1);
        },
        function () {
          removeNext(index + 1);
        }
      );
    }

    removeNext(0);
  }

  function syncCartUiFromCart(cart) {
    if (!cart) return;
    latestCartState = cart;

    updateCartRequiresShippingState(cart);
    applyShippingRequiredState(cart);
    updateCheckoutButtonAmount(cart);
    updateDeliveryEstimate(cart);
    updateFreeDeliveryProgress(cart);
    applyPickupOnlyState(cart);
    updateDeliveryAreaUi(cart);
    syncExpressCheckoutState(cart);
    applyExpressAreaState(cart);
    applyCheckoutState(cart);
    removeAreaInvalidExpressSelections(cart);
    removeThresholdInvalidExpressSelections(cart);
    applyExpressWindowState();
    removeUnavailableExpressSelections();
    unlockZapietIfExpress();
  }

  // COMPONENT: Express delivery window keeps the optional service tied to the merchant-configured UK operating hours.
  function getTimePartsInZone(timeZone) {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
    } catch (error) {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
    }
  }

  function getExpressMinutesInZone(timeZone) {
    var parts = getTimePartsInZone(timeZone);
    var hour = 0;
    var minute = 0;

    parts.forEach(function (part) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });

    return hour * 60 + minute;
  }

  function isExpressWindowOpen(wrapper) {
    var startHour = parseInt(wrapper.getAttribute('data-express-window-start') || '10', 10);
    var endHour = parseInt(wrapper.getAttribute('data-express-window-end') || '16', 10);
    var timeZone = wrapper.getAttribute('data-express-timezone') || 'Europe/London';
    var currentMinutes = getExpressMinutesInZone(timeZone);
    var startMinutes = startHour * 60;
    var endMinutes = endHour * 60;

    return currentMinutes >= startMinutes && currentMinutes < endMinutes;
  }

  function shouldShowExpressWrapper(wrapper) {
    if (!wrapper) return false;
    if (!cartRequiresShipping()) return false;

    var isEligible = wrapper.dataset.expressEligible === 'true';
    var hasSelection = Array.prototype.slice
      .call(wrapper.querySelectorAll('[data-express-checkout]'))
      .some(function (checkbox) {
        return checkbox.checked;
      });

    return isEligible || hasSelection;
  }

  function applyExpressWindowState() {
    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var isOpen = isExpressWindowOpen(wrapper);
      var status = wrapper.querySelector('[data-express-status]');
      var closedMessage = wrapper.getAttribute('data-express-closed-message') || '';
      var shouldShow = shouldShowExpressWrapper(wrapper) && isOpen;

      wrapper.dataset.expressAvailable = isOpen ? 'true' : 'false';
      wrapper.hidden = !shouldShow;
      wrapper.classList.toggle('express-checkout--hidden', !shouldShow);
      wrapper.classList.toggle('express-checkout--closed', !isOpen);

      wrapper.querySelectorAll('[data-express-checkout]').forEach(function (checkbox) {
        checkbox.disabled = !isOpen;

        if (isOpen) {
          checkbox.removeAttribute('aria-disabled');
        } else {
          checkbox.setAttribute('aria-disabled', 'true');
        }
      });

      if (!status) return;

      status.hidden = true;
      status.textContent = shouldShow && !isOpen ? closedMessage : '';
    });
  }

  // EVENT: When the window is closed, any already-selected express fee products are removed so checkout cannot continue with an ineligible same-day surcharge.
  function removeUnavailableExpressSelections() {
    if (expressWindowSyncInFlight) return;

    var variantIds = [];

    document.querySelectorAll('[data-express-checkout-wrapper][data-express-available="false"] [data-express-checkout]').forEach(function (checkbox) {
      if (!checkbox.checked) return;

      var variantId = checkbox.getAttribute('data-variant-id');
      if (!variantId || variantIds.indexOf(String(variantId)) !== -1) return;

      variantIds.push(String(variantId));
    });

    if (!variantIds.length) return;

    expressWindowSyncInFlight = true;
    applyCheckoutState();

    function removeNext(index) {
      if (index >= variantIds.length) {
        window.location.reload();
        return;
      }

      setVariantQty(
        variantIds[index],
        0,
        function () {
          removeNext(index + 1);
        },
        function () {
          removeNext(index + 1);
        }
      );
    }

    removeNext(0);
  }

  function handleExpressToggle(event) {
    var checkbox = event.target;
    if (!checkbox || !checkbox.matches('[data-express-checkout]')) return;
    if (expressAreaSyncInFlight || expressWindowSyncInFlight) return;

    var wrapper = checkbox.closest('[data-express-checkout-wrapper]');

    if (wrapper && wrapper.dataset.expressAvailable === 'false') {
      checkbox.checked = false;
      return;
    }

    var variantId = checkbox.getAttribute('data-variant-id');
    var quantity = parseInt(checkbox.getAttribute('data-quantity') || '1', 10);

    if (!variantId || quantity <= 0) {
      checkbox.checked = false;
      return;
    }

    function reloadCart() {
      window.location.reload();
    }

    setExpressActionMessage(wrapper, '');

    if (checkbox.checked) {
      var allExpress = Array.prototype.slice.call(document.querySelectorAll('[data-express-checkout]'));
      var params = {};

      allExpress.forEach(function (cb) {
        if (!cb) return;

        var otherId = cb.getAttribute('data-variant-id');
        if (!otherId) return;

        cb.checked = String(otherId) === String(variantId);
        params['updates[' + String(otherId) + ']'] = String(String(otherId) === String(variantId) ? quantity : 0);
      });

      postForm(
        '/cart/update.js',
        params,
        reloadCart,
        function () {
          checkbox.checked = false;
          setExpressActionMessage(
            wrapper,
            'Unable to update express delivery right now. Please refresh the cart and confirm the Express delivery product is available.'
          );
        }
      );
      return;
    }

    setVariantQty(
      variantId,
      0,
      reloadCart,
      function () {
        checkbox.checked = true;
        setExpressActionMessage(
          wrapper,
          'Unable to update express delivery right now. Please refresh the cart and try again.'
        );
      }
    );
  }

  function refreshCartUi() {
    initFreeshippingBars();
    initFsbAddonsCarousels();
    initFsbAddonQtySteppers();
    initZapietDomSelectionObserver();
    initCheckoutTotalObserver();
    initCheckoutStateObserver();
    syncAgreementAttributeIfNeeded();
    updateCartNoteCounter();
    syncCheckoutButtonToSummary();
    applyShippingRequiredState();
    updateDeliveryEstimate();
    updateFreeDeliveryProgress(getEffectiveCart());
    applyPickupOnlyState();
    updateDeliveryAreaUi();
    applyExpressAreaState();
    applyExpressWindowState();
    removeUnavailableExpressSelections();
    applyCheckoutState();
    syncCartSavingsState();
    unlockZapietIfExpress();
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-delivery-area-select]')) {
      var areaKey = normalizeDeliveryArea(event.target.value);
      var wrapper = event.target.closest('[data-delivery-area-block]');
      var ruleInput = wrapper ? wrapper.querySelector('[data-delivery-rule-input]') : null;

      if (ruleInput) {
        ruleInput.value = areaKey;
      }

      updateDeliveryAreaUi();
      applyExpressAreaState();
      applyCheckoutState();
      syncDeliveryAreaAttribute(event.target.value, areaKey);
      return;
    }

    if (event.target && event.target.matches('[data-cart-agreement]')) {
      syncAgreementAttributeIfNeeded();
      applyCheckoutState();
      return;
    }

    if (event.target && event.target.matches('[data-quantity-input]')) {
      scheduleCheckoutButtonSync();
    }

    handleExpressToggle(event);
  });

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches('[data-cart-note]')) {
      updateCartNoteCounter();
    }

    if (event.target && event.target.closest('#storePickupApp')) {
      scheduleZapietDomSelectionSync();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('#storePickupApp')) {
      scheduleZapietDomSelectionSync();
    }

    var checkoutTrigger = event.target && event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkoutTrigger) {
      if (isZapietOwnedCheckoutTrigger(checkoutTrigger)) {
        event.preventDefault();

        if (!isCheckoutAllowed()) {
          event.stopImmediatePropagation();
          applyCheckoutState();
        }

        return;
      }

      if (!isCheckoutAllowed()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyCheckoutState();
        return;
      }
    }

    if (
      event.target &&
      event.target.closest('[data-increase-quantity], [data-decrease-quantity], [data-remove-key]')
    ) {
      scheduleCheckoutButtonSync();
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    document.dispatchEvent(new CustomEvent('fsb:cart:update'));
    applyCheckoutState();
    syncCartSavingsState();
    syncCartUiFromCart(event.detail && event.detail.cart);
    scheduleCheckoutButtonSync();

    if (fsbRefreshTimer) clearTimeout(fsbRefreshTimer);
    fsbRefreshTimer = setTimeout(function () {
      refreshFreeshippingSection();
    }, 120);
  });

  document.addEventListener('theme:cart:reload', function () {
    setTimeout(refreshCartUi, 50);
    scheduleCheckoutButtonSync();
  });

  document.addEventListener('submit', function (event) {
    var checkoutBtn = event.submitter;
    if (!checkoutBtn || !checkoutBtn.matches('button[name="checkout"], input[name="checkout"]')) return;

    if (isZapietOwnedCheckoutTrigger(checkoutBtn)) {
      event.preventDefault();
      applyCheckoutState();
      return;
    }

    if (!isCheckoutAllowed()) {
      event.preventDefault();
      applyCheckoutState();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(refreshCartUi, 80);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initZapietCheckoutValidation();
    bindZapietWidgetEvents();
    refreshCartUi();
    initCheckoutStateObserver();
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart sync failed: ' + response.status);
        }

        return response.json();
      })
      .then(function (cart) {
        syncAgreementCheckboxStateFromCart(cart);
        syncCartUiFromCart(cart);
      })
      .catch(function (error) {
        console.error(error);
      });
    setTimeout(bindZapietWidgetEvents, 300);
    setTimeout(bindZapietWidgetEvents, 1200);
    setTimeout(unlockZapietIfExpress, 500);
    setTimeout(unlockZapietIfExpress, 1500);
    setInterval(function () {
      bindZapietWidgetEvents();
      applyExpressWindowState();
      removeUnavailableExpressSelections();
    }, 60000);
  });
})();
